<template>
  <div>
    <span
      class="tw-text-2xl tw-font-semibold"
      :class="{ 'tw-text-success-500': isCourseFree }"
      test_id="price-per-hour"
    >
      {{ priceRate }}
    </span>
    <div class="tw-mt-1 tw-text-xs tw-text-neutral-400">Price per hour</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  hourRate: {
    type: String,
    required: true,
  },
  hourRateCurrency: {
    type: String,
    required: true,
  },
})

const isCourseFree = computed(() => Number(props.hourRate) === 0)
const priceRate = computed(() => {
  if (isCourseFree.value) return 'Free'
  return `${props.hourRateCurrency} / hour`
})
</script>
